'use strict';

var widgets = [];
document.querySelectorAll('.donation-widget').forEach(function (widget) {
  widgets.push({
    root: widget,
    otg: widget.querySelector('.One.Time'),
    rgm: widget.querySelector('.Monthly'),
    rga: widget.querySelector('.Annually'),
    amountButtons: widget.querySelectorAll('.amount-button'),
    donateInput: widget.querySelector('#donateAmountInput'),
    form: widget.querySelector('#donation-form'),
    clampTimeout: null,
    errorContainer: widget.querySelector('.error-container'),
    orderErrorContainer: widget.querySelector('.order-error'),
    querySelector: function (selector) {
      return this.root.querySelector(selector);
    },
    querySelectorAll: function (selector) {
      return this.root.querySelectorAll(selector);
    }
  })
})

$(document).ready(function () {
  widgets.forEach(function (widget) {
    initialize(widget);
    registerDonationTypeListener(widget);
    registerDonationAmountListener(widget);
    registerButtons(widget);
    registerExpiryFormatting(widget);
  });
});

function initialize(widget) {
  hideAll(widget, '.section-two');
  hideAll(widget, '.section-three');
  hideAll(widget, '.section-four');
  clearActiveType(widget);
  var subhead = widget.querySelector('.donation-subheader');
  var defaultOneTimeSubheader = 'Select Your One-Time Donation Amount';
  var defaultMonthlySubheader = 'Select Your Monthly Donation Amount';
  var defaultAnnualSubheader = 'Select Your Annual Donation Amount';

  widget.subHeaderOverrideOneTime = subhead ? subhead.getAttribute('data-subheader-override-onetime') : '';
  widget.subHeaderOverrideMonthly = subhead ? subhead.getAttribute('data-subheader-override-monthly') : '';
  widget.subHeaderOverrideAnnual = subhead ? subhead.getAttribute('data-subheader-override-annual') : '';


  //show initial amounts, set initial value
  if (widget.querySelectorAll('.otg-amount').length > 0) {
    widget.otg.classList.add('active');
    //amount classes
    showAll(widget, '.otg-amount');
    if (subhead) {
      subhead.textContent = widget.subHeaderOverrideOneTime || defaultOneTimeSubheader;
    }
    // Show placeholder for custom amount instead -JS 11-Nov-2025
    $('.otg-amount .amount-button').first().addClass('active');
    //set amount
    setAmount(widget, parseInt($('.otg-amount .amount-button').first().data('amount')));

  } else if (widget.querySelectorAll('.rgm-amount').length > 0) {
    widget.rgm.classList.add('active');
    //amount classes
    showAll(widget, '.rgm-amount');
    if (subhead) {
      subhead.textContent = widget.subHeaderOverrideMonthly || defaultMonthlySubheader;
    }
    // Show placeholder for custom amount
    $('.rgm-amount .amount-button').first().addClass('active');
    //set amount
    setAmount(widget, parseInt($('.rgm-amount .amount-button').first().data('amount')));

  } else if (widget.querySelectorAll('.rga-amount').length > 0) {
    widget.rga.classList.add('active');
    //amount classes
    showAll(widget, '.rga-amount');
    if (subhead) {
      subhead.textContent = widget.subHeaderOverrideAnnual || defaultAnnualSubheader;
    }
    // Show placeholder for custom amount
    $('.rga-amount .amount-button').first().addClass('active');
    //set amount
    setAmount(widget, parseInt($('.rga-amount .amount-button').first().data('amount')));
  }
}

function registerDonationTypeListener(widget) {
  var subhead = widget.querySelector('.donation-subheader');
  var defaultOneTimeSubheader = 'Select Your One-Time Donation Amount';
  var defaultMonthlySubheader = 'Select Your Monthly Donation Amount';
  var defaultAnnualSubheader = 'Select Your Annual Donation Amount';

  if (widget.otg) {
    widget.otg.addEventListener('click', function () {
      clearActiveType(widget);
      clearAmounts(widget);
      widget.otg.classList.add('active');
      showAll(widget, '.otg-amount');
      // widget.querySelector('.otg-amount .amount-button').first().classList.add('active');
      setAmount(widget, widget.querySelector('.otg-amount .amount-button').dataset.amount);
      if (subhead) {
        subhead.textContent = widget.subHeaderOverrideOneTime || defaultOneTimeSubheader;
      }

    });
  }

  if (widget.rgm) {
    widget.rgm.addEventListener('click', function () {
      clearActiveType(widget);
      clearAmounts(widget);
      widget.rgm.classList.add('active');
      showAll(widget, '.rgm-amount');
      // widget.querySelector('.rgm-amount .amount-button').first().classList.add('active');
      setAmount(widget, widget.querySelector('.rgm-amount .amount-button').dataset.amount);
      if (subhead) {
        subhead.textContent = widget.subHeaderOverrideMonthly || defaultMonthlySubheader;
      }

    });
  }

  if (widget.rga) {
    widget.rga.addEventListener('click', function () {
      clearActiveType(widget);
      clearAmounts(widget);
      widget.rga.classList.add('active');
      showAll(widget, '.rga-amount');
      // widget.querySelector('.rga-amount .amount-button').first().classList.add('active');
      setAmount(widget, widget.querySelector('.rga-amount .amount-button').dataset.amount);
      if (subhead) {
        subhead.textContent = widget.subHeaderOverrideAnnual || defaultAnnualSubheader;
      }

    });
  }
};


function registerDonationAmountListener(widget) {
  widget.amountButtons.forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      clearAmounts(widget);
      $(this).addClass('active');
      setAmount(widget, btn.getAttribute('data-amount'));
    });
  });

  widget.donateInput.addEventListener('input', () => {
    clearTimeout(widget.clampTimeout);
    widget.clampTimeout = setTimeout(() => {
      const val = parseInt(widget.donateInput.value, 10);
      if (!isNaN(val) && val < 10) {
        widget.donateInput.value = 10;
      }
    }, 500);
  });
}

function validateForm(widget) {
  // reset any messages
  widget.orderErrorContainer.textContent = '';
  widget.orderErrorContainer.classList.add('hidden');
  widget.errorContainer.textContent = '';
  widget.errorContainer.classList.add('hidden');
  widget.querySelectorAll('.user-info').forEach(function (el) {
    el.classList.remove('is-invalid');
  });
  widget.querySelectorAll('.cc-info').forEach(function (el) {
    el.classList.remove('is-invalid');
  });

  if (!widget.form.checkValidity()) {
    // find the first invalid field and show its message
    var invalid = widget.form.querySelector(':invalid');
    widget.errorContainer.classList.remove('hidden');
    widget.errorContainer.textContent = 'Please fill in all required fields';
    // navigate to relevant page
    widget.form.querySelectorAll('.form-section').forEach(function (section) {
      if (section.contains(invalid)) {
        section.classList.remove('hidden');
      } else {
        section.classList.add('hidden');
      }
    });
    invalid.focus();
    return false;
  }

  var exp = widget.form.elements['expiry'].value;
  if (!/^(0[1-9]|1[0-2])\/\d{2}$/.test(exp)) {
    widget.form.elements['expiry'].focus();
    widget.errorContainer.classList.remove('hidden');
    widget.errorContainer.textContent = 'Expiry must be in MM/YY format.';
    return false;
  }

  var cvc = widget.form.elements['cvc'].value;
  if (!/^\d{3,4}$/.test(cvc)) {
    widget.form.elements['cvc'].focus();
    widget.errorContainer.classList.remove('hidden');
    widget.errorContainer.textContent = 'CVC must be 3 or 4 digits.';
    return false;
  }

  return true;
}

function validateAmount(widget) {
  // reset any messages
  widget.querySelectorAll('.user-info').forEach(function (el) {
    el.classList.remove('is-invalid');
  });
  widget.querySelectorAll('.cc-info').forEach(function (el) {
    el.classList.remove('is-invalid');
  });
  widget.errorContainer.textContent = '';
  widget.errorContainer.classList.add('hidden');

  var amt = parseFloat(widget.donateInput.value);
  if (isNaN(amt) || amt < 10) {
    widget.donateInput.focus();
    widget.errorContainer.classList.remove('hidden');
    widget.errorContainer.textContent = 'Please enter an amount of at least $10.';
    return false;
  }
  return true;
}

function clearActiveType(widget) {
  if (widget.otg && widget.otg.classList) {
    widget.otg.classList.remove('active');
  }
  if (widget.rgm && widget.rgm.classList) {
    widget.rgm.classList.remove('active');
  }
  if (widget.rga && widget.rga.classList) {
    widget.rga.classList.remove('active');
  }
  hideAll(widget, '.gift-amount');

}

function clearAmounts(widget) {
  widget.querySelectorAll('.amount-button.active').forEach(function (el) {
    el.classList.remove('active');
  });
  // Clear amount in input field
  widget.donateInput.value = '';
  widget.donateInput.removeAttribute('value');
}

function setAmount(widget, amount) {
  widget.donateInput.value = parseInt(amount);
  widget.donateInput.setAttribute('value', parseInt(amount));
}

function registerButtons(widget) {
  var first = widget.querySelector('.firstButton');
  var second = widget.querySelector('.secondButton');
  var third = widget.querySelector('.thirdButton');
  var backBtns = widget.querySelectorAll('.backButton');
  var msgEl = document.getElementById('donation-message');


  //on click, move to next stage
  first.addEventListener('click', function () {
    var validated = validateAmount(widget);
    if (validated) {
      hideAll(widget, '.section-one');
      showAll(widget, '.section-two');
      hideAll(widget, '.section-three');
    }

  });
  second.addEventListener('click', function () {
    var validated = validateAmount(widget);
    if (validated) {
      hideAll(widget, '.section-one');
      hideAll(widget, '.section-two');
      showAll(widget, '.section-three');
    }

  });

  //Assign both back buttons
  backBtns[0].addEventListener('click', function () {
    showAll(widget, '.section-one');
    hideAll(widget, '.section-two');
    hideAll(widget, '.section-three');
  });
  backBtns[1].addEventListener('click', function () {
    hideAll(widget, '.section-one');
    showAll(widget, '.section-two');
    hideAll(widget, '.section-three');
  });


  //on click, checkout
  third.addEventListener('click', function () {
    var validated = validateForm(widget);
    var fd = new FormData(widget.form);
    var data = populateFormData(widget, fd);
    const urlEncoded = new URLSearchParams(data).toString();
    var donationOrderUrl = $('.donation-place-order-url').val();
    if (validated) {
      disableSubmitButton(third);
      fetch(donationOrderUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: urlEncoded
      })
        .then(function (res) { return res.json(); })
        .then(function (json) {
          if (json.success) {
            showAll(widget, '.section-four');
            hideAll(widget, '.section-three');
          } else {
            msgEl.textContent = 'Error: ' + (json.error || 'Could not add to cart');
          }
          msgEl.classList.remove('hidden');
          restoreSubmitButton(third);
        })
        .catch(function (err) {
          console.error('Donation order error:', err);
          console.error(err.stack);
          widget.orderErrorContainer.textContent = 'We ran into an error making your order. Please check the information above and try again';
          widget.orderErrorContainer.classList.remove('hidden');
          restoreSubmitButton(third);
        });
    }
  })

  const countrySelect = widget.querySelector('#country');

  countrySelect.addEventListener('change', function () {
    updateStateDropdown(widget);
  });
  updateStateDropdown(widget);

}

// Copied from checkoutWidget.js  -JS 11-Nov-2025
function registerExpiryFormatting(widget) {
  var expiry = widget.querySelector('input[name="expiry"], #expiry');
  if (!expiry) return;

  // Format on every input, unless skipFormat was set by Backspace
  expiry.addEventListener('input', function (e) {

    if (e.data == null) {
      // consume the flag and do not format on this input
      return;
    }

    var raw = expiry.value || '';
    // Keep only digits
    var digits = raw.replace(/\D/g, '');

    if (digits.length === 0) {
      expiry.value = '';
      return;
    }

    // Limit to max 4 digits (MMYY)
    if (digits.length > 4) digits = digits.slice(0, 4);

    // If there's only one digit entered
    if (digits.length === 1) {
      var d = digits[0];
      if (d === '0') {
        // If the user typed '0' first, do not prepend another 0 or add a slash yet.
        expiry.value = '0';
      } else if (d !== '1') {
        // For single-digit months other than '1' (and not '0'), prepend a leading zero and add slash
        expiry.value = '0' + d + '/';
      } else {
        // this adds a leading zero for '1' if a slash is added after a 1
        if (e.data === '/') {
          expiry.value = '01/';
        }
        // if input is not a slash keep '1' as-is to allow user to type second digit (e.g., to form 10,11,12)
      }
      return;
    }


    // When two or more digits exist, ensure a slash after the month
    var month = digits.slice(0, 2);
    var year = digits.slice(2);

    // If month is '00', change to '01'
    if (month === '00') {
      month = '01';
    } else if (parseInt(month, 10) > 12) {
      // If month is greater than 12, set to '12'
      month = '12';
    }

    var formatted = month + '/';
    if (year.length > 0) formatted += year;

    expiry.value = formatted;
  });
}

function showAll(widget, sectionQuery) {
  widget.querySelectorAll(sectionQuery).forEach(function (section) {
    section.classList.remove('hidden');
  });
}
function hideAll(widget, sectionQuery) {
  widget.querySelectorAll(sectionQuery).forEach(function (section) {
    section.classList.add('hidden');
  });
}

// Spinner HTML, styles, & methods
var spinnerHtml = '<span class="pd-spinner" aria-hidden="true"></span><span class="pd-spinner-text">Processing...</span>';

function ensureSpinnerStyle() {
  if (document.getElementById('pd-spinner-style')) return;
  var css = '\n    .pd-spinner{display:inline-block;width:18px;height:18px;border:2px solid rgba(0,0,0,0.12);border-top-color:#000;border-radius:50%;animation:pd-spin 0.6s linear infinite;vertical-align:middle;margin-right:8px;}\n    .pd-spinner-text{vertical-align:middle;}\n    @keyframes pd-spin{to{transform:rotate(360deg)}}\n  ';
  var style = document.createElement('style');
  style.id = 'pd-spinner-style';
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
}

function disableSubmitButton(btn) {
  ensureSpinnerStyle();
  // store original content so we can restore it later
  if (!btn.dataset.originalHtml) {
    btn.dataset.originalHtml = btn.innerHTML;
  }
  btn.disabled = true;
  btn.classList.add('disabled');
  btn.setAttribute('aria-busy', 'true');
  btn.innerHTML = spinnerHtml;
}

function restoreSubmitButton(btn) {
  var original = btn.dataset.originalHtml;
  if (original !== undefined) {
    btn.innerHTML = original;
    delete btn.dataset.originalHtml;
  }
  btn.disabled = false;
  btn.classList.remove('disabled');
  btn.removeAttribute('aria-busy');
}

// End copied from checkoutWidget.js


function getRedirectParameterString(productId, customAmount) {
  return 'redirect=pid,' + productId + ',qty,1,custom,' + customAmount + ',atc,true';
}

function populateFormData(widget, fd) {
  var address = fd.get('adress');
  var zip = fd.get('zip');
  var country = fd.get('country');
  var state = fd.get('state');
  var city = fd.get('city');
  var email = fd.get('email');
  var phone = fd.get('phone');
  var firstName = fd.get('firstName');
  var lastName = fd.get('lastName');
  var cardNum = fd.get('cardNumber');
  var expiry = fd.get('expiry');
  var cvc = fd.get('cvc');
  var oneTimeGiftSKU = fd.get('oneTimeGiftSKU');
  var monthlyGiftSKU = fd.get('monthlyGiftSKU');
  var annualGiftSKU = fd.get('annualGiftSKU');

  var data = {
    amount: widget.donateInput.value,
    type: widget.querySelector('.type-button.active').dataset.type,
    address1: address, zip: zip,
    country: country, state: state,
    city: city, email: email,
    phone: phone, firstName: firstName,
    lastName: lastName, cardNum: cardNum,
    expires: expiry,
    cvv: cvc,
    oneTimeGiftSKU: oneTimeGiftSKU,
    monthlyGiftSKU: monthlyGiftSKU,
    annualGiftSKU: annualGiftSKU
  };

  return data;
}


function updateStateDropdown(widget) {
  const stateSelect = widget.querySelector('#state');
  const countrySelect = widget.querySelector('#country');


  // Clear out any existing options
  stateSelect.innerHTML = '';

  // Get the currently selected country ('US' or 'CA')
  const selectedCountry = countrySelect.value;

  // Get the corresponding states/provinces from our data object
  const regions = regionData[selectedCountry];

  // Loop through the object and create <option> elements
  if (regions) {
    for (const [value, label] of Object.entries(regions)) {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = label;

      // If it's the default prompt, make it disabled but selected
      if (value === '') {
        option.disabled = true;
        option.selected = true;
      }

      stateSelect.appendChild(option);
    }
  }

}


const regionData = {
  US: {
    '': 'Select a State',
    'AL': 'Alabama',
    'AK': 'Alaska',
    'AZ': 'Arizona',
    'AR': 'Arkansas',
    'CA': 'California',
    'CO': 'Colorado',
    'CT': 'Connecticut',
    'DE': 'Delaware',
    'DC': 'District Of Columbia',
    'FL': 'Florida',
    'GA': 'Georgia',
    'HI': 'Hawaii',
    'ID': 'Idaho',
    'IL': 'Illinois',
    'IN': 'Indiana',
    'IA': 'Iowa',
    'KS': 'Kansas',
    'KY': 'Kentucky',
    'LA': 'Louisiana',
    'ME': 'Maine',
    'MD': 'Maryland',
    'MA': 'Massachusetts',
    'MI': 'Michigan',
    'MN': 'Minnesota',
    'MS': 'Mississippi',
    'MO': 'Missouri',
    'MT': 'Montana',
    'NE': 'Nebraska',
    'NV': 'Nevada',
    'NH': 'New Hampshire',
    'NJ': 'New Jersey',
    'NM': 'New Mexico',
    'NY': 'New York',
    'NC': 'North Carolina',
    'ND': 'North Dakota',
    'OH': 'Ohio',
    'OK': 'Oklahoma',
    'OR': 'Oregon',
    'PA': 'Pennsylvania',
    'RI': 'Rhode Island',
    'SC': 'South Carolina',
    'SD': 'South Dakota',
    'TN': 'Tennessee',
    'TX': 'Texas',
    'UT': 'Utah',
    'VT': 'Vermont',
    'VA': 'Virginia',
    'WA': 'Washington',
    'WV': 'West Virginia',
    'WI': 'Wisconsin',
    'WY': 'Wyoming'
  },
  CA: {
    '': 'Select a Province/Territory',
    'AB': 'Alberta',
    'BC': 'British Columbia',
    'MB': 'Manitoba',
    'NB': 'New Brunswick',
    'NL': 'Newfoundland and Labrador',
    'NS': 'Nova Scotia',
    'NT': 'Northwest Territories',
    'NU': 'Nunavut',
    'ON': 'Ontario',
    'PE': 'Prince Edward Island',
    'QC': 'Quebec',
    'SK': 'Saskatchewan',
    'YT': 'Yukon'
  }
};